import { AnimationData } from './types';

export const CAT_ANIMATION_MAP: AnimationData[] = [
	{ file: 'cat05_idle_strip8.png', key: 'idle', frames: 8 },
	{ file: 'cat05_idle_blink_strip8.png', key: 'idle_blink', frames: 8 },
	{ file: 'cat05_walk_strip8.png', key: 'walk', frames: 8 },
	{ file: 'cat05_run_strip4.png', key: 'run', frames: 4 },
	{ file: 'cat05_jump_strip4.png', key: 'jump', frames: 4 },
	{ file: 'cat05_crouch_strip8.png', key: 'crouch', frames: 8 },
	{ file: 'cat05_sneak_strip8.png', key: 'sneak', frames: 8 },
	{ file: 'cat05_attack_strip7.png', key: 'attack', frames: 7 },
	{ file: 'cat05_hurt_strip4.png', key: 'hurt', frames: 4 },
	{ file: 'cat05_wallclimb_strip8.png', key: 'wallclimb', frames: 8 },
	{ file: 'cat05_wallgrab_strip8.png', key: 'wallgrab', frames: 8 },
	{ file: 'cat05_fall_strip3.png', key: 'fall', frames: 3 },
	{ file: 'cat05_land_strip2.png', key: 'land', frames: 2 },
	{ file: 'cat05_ledgeclimb_struggle_strip12.png', key: 'ledgestruggle', frames: 12 },
	{ file: 'cat05_die_strip8.png', key: 'die', frames: 8 },
	{ file: 'cat05_sit_strip8.png', key: 'sit', frames: 8 },
	{ file: 'cat05_sleep_strip8.png', key: 'sleep', frames: 8 },
];
